// NGRX
import {Store, select} from '@ngrx/store';
// CRUD
import {BaseDataSource, QueryResultsModel} from '../../_base/crud';
// State
import {AppState} from '../../reducers';
// Selectirs
import {selectMeasurementMethodologiesQueryResult, selectMeasurementMethodologiesPageLoading, selectMeasurementMethodologiesShowInitWaitingMessage} from '../_selectors/measurement-methodology.selectors';

export class MeasurementMethodologiesDataSource extends BaseDataSource {
    trashed: number = 0;

    constructor(private store: Store<AppState>) {
        super();

        this.loading$ = this.store.pipe(
            select(selectMeasurementMethodologiesPageLoading)
        );

        this.isPreloadTextViewed$ = this.store.pipe(
            select(selectMeasurementMethodologiesShowInitWaitingMessage)
        );

        this.store.pipe(
            select(selectMeasurementMethodologiesQueryResult)
        ).subscribe((response: QueryResultsModel) => {
            this.paginatorTotalSubject.next(response.totalCount);
            this.entitySubject.next(response.items);
        });

    }
}
